import { useCallback, useContext } from 'react';
import styled, { css } from 'styled-components';
import Typography from 'kingpin/atoms/Typography';
import { AccountTodayOverrideContext } from 'contextProviders/SplashScreenProviders/UserAndAccountProviders/AccountTodayOverrideProvider';
import isoDateToAmerican from '../../../../isoDateToAmerican';
import { UIVersionContext } from '../../../../contextProviders/SplashScreenProviders/UserAndAccountProviders/UIVersionProvider';
import Button from '../../../../kingpin/atoms/Button';
import Tooltip from '../../../../components/Tooltip';

const V1V2Mixin = css`
  position: absolute;
  bottom: 40px;
  right: 40px;
  z-index: 1000;
`;

const OverlayDiv = styled.div<{ isV3: boolean }>`
  border: 1px solid var(--color-badge-warning-border);
  border-radius: 8px;
  background-color: var(--color-badge-warning-bg);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  ${(props) => !props.isV3 && V1V2Mixin}
  gap: 8px;
`;

const TodayOverrideOverlay = () => {
  const { isTransient, todayOverride, onTodayOverrideUpdated } = useContext(
    AccountTodayOverrideContext,
  );
  const { isV3 } = useContext(UIVersionContext);
  const onRemoveClicked = useCallback(() => {
    onTodayOverrideUpdated(undefined);
  }, [onTodayOverrideUpdated]);

  if (!isTransient || !todayOverride) {
    return null;
  }

  return (
    <OverlayDiv isV3={isV3}>
      <Typography.Body type={'Label'} isEllipsis>
        {`Today has been set to: ${isoDateToAmerican(todayOverride)}`}
      </Typography.Body>
      <Tooltip content={'Remove override'}>
        <Button
          size={'Small'}
          type={'Secondary'}
          onClick={onRemoveClicked}
          icon={'cross'}
        />
      </Tooltip>
    </OverlayDiv>
  );
};

export default TodayOverrideOverlay;
